import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['suppliers']);

export const suppliersQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
  financialAccount: (id: number) => builder('financial-account', id),
  chargeAccountLines: (id: number) => builder('charge-account-lines', id),
  infinite: (params: object) => builder('infinite', params),
};
